import * as actionTypes from '../../actionTypes'
import { updateObject } from '../../../utility/Redux'
const initialState = {
    data: [],
    selected: null,
    loading: true,
    error: false
}

const reducer =(state = initialState, action) => {
    switch(action.type){
        case actionTypes.EXAMPLE_SET_LOADING:
            return updateObject(state, {loading: action.loading})
        case actionTypes.EXAMPLE_FETCH_SUCCESS:
            return updateObject(state, {data: action.data, loading: false})
        case actionTypes.EXAMPLE_ADD_SUCCESS:
            return updateObject(state, {loading: true})
        case actionTypes.EXAMPLE_GET_SUCCESS:
            return updateObject(state, {selected: action.data, loading: false})
        case actionTypes.EXAMPLE_UPDATE_SUCCESS:
            return updateObject(state, {selected: null, loading: true})
        case actionTypes.EXAMPLE_CLEAR_SELECTED:
            return updateObject(state, {selected: action.selected})
        default:
            return state
    }
}

export default reducer